import React from "react";
import { AccordionCardView } from "./accordion-card-view";
import type { AccordionCardState } from "./models/accordion-card-state";
import type { Properties } from "./properties";

const AccordionCard = (props: Properties) => {
	const defaultState: AccordionCardState = {
		open: props.open || false,
	};
	const [state, setState] = React.useState<AccordionCardState>(defaultState);

	const onToggleOpen = () => {
		if (props.onToggleOpen) {
			props.onToggleOpen(!state.open);
		}
		setState({ ...state, open: !state.open });
	};

	// #region LIFECYCLE
	React.useEffect(() => {
		if (props.open !== undefined && props.open !== state.open) {
			setState({ ...state, open: props.open });
		}
	}, [props.open]);

	return (
		<AccordionCardView
			{...props}
			open={state.open}
			onToggleOpen={onToggleOpen}
		/>
	);
};

export { AccordionCard };
